import React from 'react'

const AdminTrucksIndex = () => {
    return (
        <div>I am the TrucksIndex</div>
    )
}

export default AdminTrucksIndex
